import React, { useEffect, useState } from 'react';

import { throttle } from 'lib/throttle';

import Icon from 'components/icon/icon';

const GoToTopButton = () => {
  const [scrollTopAvailable, setScrollTopAvailable] = useState(false);
  const onClickHandler = () => {
    let top = global?.document.getElementById('tab-list')?.getBoundingClientRect().top || 0;

    if (top !== 0) {
      const headerElement = global?.document.getElementById('tab-list');

      if (headerElement) {
        const headerHeight =
          parseFloat(getComputedStyle(headerElement).getPropertyValue('--header-height')) || 0;

        top += window.scrollY - headerHeight;
      }
    }
    global.window.scrollTo(0, top);
  };

  const updateScrollProgress = () => {
    const windowHeight = global.window.innerHeight;
    const winScroll = global.document.body.scrollTop || global.document.documentElement.scrollTop;

    setScrollTopAvailable(winScroll > windowHeight);
  };

  useEffect(() => {
    updateScrollProgress();

    global.window.addEventListener('scroll', throttle(updateScrollProgress, 300), {
      passive: true,
    });

    return () => {
      global.window.removeEventListener('scroll', throttle(updateScrollProgress, 300));
    };
  }, []);

  return (
    <button
      className="go-to-top-button"
      aria-label="scroll to the top"
      style={{
        opacity: scrollTopAvailable ? 1 : 0,
        pointerEvents: scrollTopAvailable ? 'all' : 'none',
      }}
      onClick={onClickHandler}
    >
      <Icon name={Icon.Name.GenericChevronUp} />
    </button>
  );
};

export { GoToTopButton };
